import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from 'simple-react-validator';
import { LabelText, SubmitButton, FlexContainer, H1Text, Text, Img, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { API } from "../../api";
import { SWIREPAY_URL, MESSAGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import SuccessMessageModal from "../../components/modal/successMessage";
import Logo from '../../assets/imgs/SP_Outline_logo.svg';
import FileUploader from "./components/FileUploader";
import { CheckCircleOutlined } from '@ant-design/icons';
import {Col, Row} from "react-awesome-styled-grid";


type Props = {
    history: {
        push: Function,
    },
}

const AccountVerification = (props: Props) => {
    const [, forceUpdate] = useState();
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showerrorMessage, setShowErrorMessage] = useState(false);
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [linkStatus, setLinkStatus] = useState('');
    const [documentKeyType, setDocumentKeyType] = useState('');
    const [uploadedUrl, setUploadedUrl] = useState('');
    const [fieldName, setFieldName] = useState('');
    const { location: { search } } = props;
    const [successFiles, setSuccessFiles] = useState([]);

    const params = new URLSearchParams(search);
    const gid = params.get('gid');
    const key = params.get('key');

    const simpleValidator = useRef(new SimpleReactValidator());
    simpleValidator.current.purgeFields();

    const confirm = async () => {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            simpleValidator.current.hideMessages();
            setShowErrorMessage(false);
            forceUpdate();
        
            let params = {
                responseDocumentUrl : uploadedUrl || null
            };
            setShowSpinner(true);
            try {
                const entity = await API.patch(`/custom-document-request/${gid}/response`, params, {
                    headers: {
                    'x-api-key': key ? atob(key) : null,
                    },
                })
                if (entity && entity.status === 'VALID') {
                    setTransactionModalOpen(true);
                };
                const { redirectUri } = entity;
                if (redirectUri) {
                    window.location = redirectUri;
                    return;
                }
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    if (entity?.redirectUri) {
                        window.location = `${entity?.redirectUri}`;
                    } else {
                        window.location = `${SWIREPAY_URL}`;
                    }
                }, 5000);
                localStorage.removeItem('publicKey');
            } catch (reason) {
                setShowErrorMessage(true);
                setErrorMessage(reason && reason.data ? reason.data.message : 'Unable to process request. Please try again later');
            } finally {
                setShowSpinner(false);
            }
    };

    const getOrumVerificationStatus = async () => {
        const { data : { entity } } = await API.get(`/custom-document-request/${gid}`, {
            headers: {
            'x-api-key': key ? atob(key) : null,
            },
        })
        if(entity){
            setLinkStatus(entity?.status);
            setDocumentKeyType(entity?.documentReferenceId);
            setFieldName(entity?.name);
        };
    }

    // to check if the verification link is still valid and active
    useEffect(() => {
        getOrumVerificationStatus();
    }, [gid]);

    const addSuccessFile = (fileName) => {
      setSuccessFiles(prev => (
        prev.includes(fileName) ? prev : [...prev, fileName]
      ));
    };
    
  
    return (
        <>
            <SuccessMessageModal
                isOpen={linkStatus === 'SUBMITTED'}
                successMsg={MESSAGES.ONBOARDING_DOCUMENT_STATUS.SUCCESS}
            />
            <BaseSplitPage left={
                <>
                    <FlexContainer
                        flexDirection="column"
                        position="relative"
                        display="block"
                        height="100%"
                    >
                        <div>
                            <H1Text>
                                ACCOUNT VERIFICATION
                            </H1Text>
                        </div>
                        <div style={{ position: "sticky", top: "85%" }}>
                            <Support email={null}
                                phone={null} />
                        </div>
                    </FlexContainer>
                </>
            } right={
                <>
                    <Header payment={null} />
                    <FlexContainer
                        className="pt-3 pt-lg-5"
                        box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                        display="flow-root"
                    >

                        <H1Text
                            className="px-1 px-md-4 mt-4"
                        >
                            SUBMIT DOCUMENT FOR VERIFICATION
                        </H1Text>
                        <hr className="my-2"/>
                        <div className="px-1 px-md-4 mt-2">
                            <FlexContainer flexDirection="column">
                                <div className="d-flex mt-4 mb-4">
                                  <Img src={Logo} />
                                  <H1Text className="px-1 px-md-4 mt-4">
                                    UPLOAD DOCUMENT(S)
                                  </H1Text>
                                </div>
                                <div>
                                    <div className="d-flex align-items-center mb-4" style={{ gap: '11.9rem' }}>
                                    <LabelText>{fieldName || 'Requested Document'}</LabelText>
                                    <FileUploader
                                        keyType={documentKeyType ? documentKeyType : "CUSTOM_DOCUMENT_REQUEST_RESPONSE"}
                                        endPoint="/storage/upload/kyc-document"
                                        setUrl={value => { setUploadedUrl(value); if (value) addSuccessFile(fieldName || 'Requested Document'); }}
                                        value={uploadedUrl}
                                        accept="application/pdf,image/*"
                                        type="Business"
                                        publicKeyUrl={key ? atob(key) : ''}
                                    />
                                    </div>
                                    {
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                        {simpleValidator.current.message('', uploadedUrl, 'required')}
                                    </Text>
                                    }
                                </div>
                                {successFiles.map((item) => (
                                    <Row
                                        className="d-flex align-items-center mb-4"
                                        style={{
                                            backgroundColor: 'white',
                                            padding: '1rem',
                                            borderRadius: '10px',
                                            boxShadow: '0 0 0 1px #e0e0e0',
                                            maxWidth: '315px',
                                            width: '100%'
                                        }}
                                    >
                                        <Col>
                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#000000' }}>
                                            {item}
                                        </div>
                                        <div style={{ color: '#007ED4', fontSize: '13px', marginTop: '7px' }}>
                                            Upload Complete
                                        </div>
                                        </Col>
                                        <Col>
                                          <CheckCircleOutlined style={{ color: '#00E38C', fontSize: '28px' }} />
                                        </Col>
                                    </Row>
                                ))}
                                <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                    <SubmitButton
                                        type="submit"
                                        marginTop="0px !importnat"
                                        // style={{ width: '142px' }}
                                        style={{ width: '21rem' }}
                                        onClick={() => confirm()}
                                    >
                                        SUBMIT
                                    </SubmitButton>
                                </div>
                            </FlexContainer>
                        </div>
                    </FlexContainer>
                    <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                    <SuccessModal successMsg="Upload Completed" isOpen={isTransactionSuccessModalOpen} partnerConnection={true} />
                    <Spinner isOpen={isShowSpinner} />
                    {showerrorMessage && <PaymentError header={"Error"} message={errorMessage} />}
                </>
            } />
        </>
    )
};

export default AccountVerification;
